import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { fetchEvents, fetchAssignableUsers } from "../../../utils/api.js";

export default function useCalendarData(workOrderId, violation_id, architectural_request_id) {
  const [events, setEvents] = useState([]);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const eventsResponse = await fetchEvents(workOrderId, violation_id, architectural_request_id);

        const formattedEvents = eventsResponse.data.map((event) => ({
          ...event,
          start: new Date(event.start_time),    
          end: new Date(event.end_time),
          rawStart: event.start_time,            
          rawEnd: event.end_time,
        }));
        setEvents(formattedEvents);

        const usersResponse = await fetchAssignableUsers();
        setUsers(usersResponse.data);
      } catch (error) {
        console.error("Error fetching calendar data:", error);
      }
    };
    fetchData();
  }, [workOrderId, violation_id, architectural_request_id]);

  return { events, setEvents, users };
}
